interface PaymentCancelledModalProps {
  isOpen: boolean;
  onClose: () => void;
  onRetry: () => void;
}

export default function PaymentCancelledModal({ isOpen, onClose, onRetry }: PaymentCancelledModalProps) {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/80 backdrop-blur-sm">
      <div className="relative w-full max-w-md bg-gradient-to-br from-[#1a1a1a] to-[#0a0a0a] border border-amber-500/30 rounded-3xl shadow-2xl overflow-hidden animate-fadeIn">
        {/* Warning Glow Effect */}
        <div className="absolute inset-0 bg-gradient-to-br from-amber-500/5 to-transparent pointer-events-none"></div>

        {/* Close button */}
        <button
          onClick={onClose}
          className="absolute top-6 right-6 z-10 p-2 text-white/60 hover:text-white hover:bg-white/10 rounded-full transition-all"
        >
          <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
          </svg>
        </button>

        {/* Content */}
        <div className="relative p-8">
          {/* Warning Icon */}
          <div className="flex justify-center mb-6">
            <div className="relative">
              {/* Icon container */}
              <div className="relative w-20 h-20 bg-gradient-to-br from-amber-500 to-amber-600 rounded-full flex items-center justify-center shadow-lg shadow-amber-500/30">
                <svg className="w-10 h-10 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />
                </svg>
              </div>
            </div>
          </div>

          {/* Title */}
          <h2 className="text-2xl font-bold text-white text-center mb-2">
            Payment Cancelled
          </h2>
          <p className="text-gray-400 text-center mb-6">
            Your payment was not processed
          </p>

          {/* Info Box */}
          <div className="mb-6 p-4 bg-amber-500/5 border border-amber-500/20 rounded-xl">
            <div className="flex items-start gap-3">
              <svg className="w-5 h-5 text-amber-500 mt-0.5 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
              </svg>
              <div className="text-sm text-gray-300">
                <p className="font-semibold mb-1 text-amber-400">What Happened?</p>
                <ul className="list-disc list-inside space-y-1 text-gray-400">
                  <li>The payment was cancelled before completion</li>
                  <li>No charges were made to your account</li>
                  <li>You can try again whenever you're ready</li>
                </ul>
              </div>
            </div>
          </div>

          {/* Action Buttons */}
          <div className="flex gap-3">
            <button
              onClick={onClose}
              className="flex-1 px-6 py-3 bg-white/5 hover:bg-white/10 border border-white/10 text-white rounded-xl font-semibold transition-all"
            >
              Close
            </button>
            <button
              onClick={() => {
                onClose();
                onRetry();
              }}
              className="flex-1 px-6 py-3 bg-gradient-to-r from-amber-500 to-amber-600 hover:from-amber-600 hover:to-amber-700 text-white rounded-xl font-semibold transition-all hover:shadow-lg hover:shadow-amber-500/30"
            >
              Try Again
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
